import React from 'react';
import { Container, Eyebrow, Reveal } from './landing/primitives';

const pillars = [
  { title: 'Data sovereignty', desc: 'Your data stays yours. Zero-retention policies, regional residency and dedicated deployment options.' },
  { title: 'Sub-100ms inference', desc: 'Optimized inference pipelines and global edge distribution for responses that feel instant.' },
  { title: 'Built for scale', desc: 'Architecture designed for millions of concurrent requests without compromising quality.' },
  { title: 'Enterprise security', desc: 'SOC 2 aligned infrastructure with end-to-end encryption, RBAC and full audit telemetry.' },
  { title: 'Advanced reasoning', desc: 'State-of-the-art models with deep reasoning, multi-step planning and tool use.' },
  { title: 'Open standard API', desc: 'OpenAI-compatible endpoints and SDKs for every language — a drop-in replacement.' },
];

const WhyOpenSov = () => (
  <section className="py-24 lg:py-32 border-t border-line bg-app-alt" data-testid="why-section">
    <Container>
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Eyebrow>Why OpenSov</Eyebrow>
            <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-heading font-medium tracking-tight leading-[1.08] text-content">
              Built different.<br />Built to last.
            </h2>
            <p className="mt-6 text-content-2 text-base leading-relaxed max-w-sm">
              Six principles we refuse to compromise on — architected into every layer of the platform.
            </p>
          </div>
        </Reveal>

        <div className="lg:col-span-8">
          {pillars.map((p, idx) => (
            <Reveal
              key={p.title}
              delay={idx * 0.05}
              className="group grid sm:grid-cols-12 gap-3 sm:gap-6 py-8 border-t border-line last:border-b hover:border-line-2 transition-colors duration-300"
              data-testid={`why-pillar-${idx}`}
            >
              <span className="sm:col-span-2 text-[11px] font-mono text-content-3 pt-1.5">0{idx + 1}</span>
              <h3 className="sm:col-span-4 text-xl font-heading font-medium tracking-tight text-content">{p.title}</h3>
              <p className="sm:col-span-6 text-content-2 text-sm leading-relaxed">{p.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </Container>
  </section>
);

export default WhyOpenSov;
